import React, { useEffect, useRef, useState } from 'react';
import { Container, RightContainer, Title, DescriptionInput, DescriptionText } from './styled.js';
import DescriptionIcon from '@mui/icons-material/TextSnippetOutlined';
import BottomButtonGroup from '../../../Pages/BoardPage/BoardComponents/BottomButtonGroup/BottomButtonGroup.js';
import { useDispatch, useSelector } from 'react-redux';
import { ordemServico } from '../../../../Services/cardService.js';


const OrdemServico = () => {

  const thisCard = useSelector((state) => state.card);
  
	const dispatch = useDispatch();
	const [inputFocus, setInputFocus] = useState(false);
	const [ordemServicos, setOrdemServicos] = useState(thisCard.ordemServico);
	const ref = useRef();
	const ref2 = useRef();

	const handleSaveClick = async () => {
		setInputFocus(false);
		await ordemServico(thisCard.cardId, thisCard.listId, thisCard.boardId, ordemServicos, dispatch);
	};

	useEffect(() => {
		setOrdemServicos(thisCard.ordemServico);
	}, [thisCard.ordemServico]);

	useEffect(() => {
		if (inputFocus) {
			ref.current.focus();
		}
	}, [inputFocus]);

	const handleClickOutside = (event) => {
		if (ref2.current && !ref2.current.contains(event.target)) {
			setInputFocus(false);
			setOrdemServicos(thisCard.ordemServico);
		} else {
			setInputFocus(true);
		}
	};

	useEffect(() => {
		document.addEventListener('click', handleClickOutside, true);
		return () => {
			document.removeEventListener('click', handleClickOutside, true);
		};
	});

	return (
		<Container ref={ref2}>
			<DescriptionIcon fontSize='small' />
			<RightContainer>
				<Title>Ordem de Serviço</Title>
				{ordemServicos && !inputFocus ? (
					<DescriptionText onClick={() => setInputFocus(true)}>{ordemServicos}</DescriptionText>
				) : (
					<DescriptionInput
						ref={ref}
						minHeight={inputFocus ? '5.5rem' : '2.5rem'}
						placeholder='Ordem se serviço...'
						value={ordemServicos}
						onChange={(e) => setOrdemServicos(e.target.value)}
					/>
				)}
				<div style={{ display: inputFocus ? 'block' : 'none' }}>
					<BottomButtonGroup
						closeCallback={() => {
							setInputFocus(false);
							setOrdemServicos(thisCard.ordemServico);
						}}
						clickCallback={handleSaveClick}
						title='Salvar'
					/>
				</div>
			</RightContainer>
		</Container>
	);
};

export default OrdemServico;
